import Link from "next/link";

const Footer = () => {
  return (
    <div className="relative bottom-0 h-8 w-full flex justify-center items-center bg-gray-100 text-center rounded-0 shadow">
      <Link
        href={`https://${process.env.NEXT_PUBLIC_ORGANIZATION_WEB}`}
        target="_blank"
        className="text-slate-500 text-sm font-normal leading-tight"
      >
        {process.env.NEXT_PUBLIC_ORGANIZATION_WEB} | &nbsp;
      </Link>
      <span className="text-[#2daec3] text-sm font-normal leading-tight">
        By {process.env.NEXT_PUBLIC_ORGANIZATION_NAME} {new Date().getFullYear()}
      </span>
    </div>
  );
};

export default Footer;
